import clsx from 'clsx';

interface IconProps {
  name: string;
  size?: 'small' | 'medium' | 'large';
  outlined?: boolean;
  className?: string;
}

const sizeClasses = {
  small: 'text-lg',
  medium: 'text-2xl',
  large: 'text-4xl',
};

/**
 * Google Material Icon component
 * 
 * Usage: <Icon name="gavel" /> or <Icon name="account_balance_wallet" outlined />
 * 
 * Find icons at: https://fonts.google.com/icons
 */
export default function Icon({ name, size = 'medium', outlined = false, className }: IconProps) {
  return (
    <span
      className={clsx(
        outlined ? 'material-icons-outlined' : 'material-icons',
        sizeClasses[size],
        className
      )}
    >
      {name}
    </span>
  );
}
